export class serviceplanformBO {
    id: string = "00000000-0000-0000-0000-000000000000"
    clientId: string = "00000000-0000-0000-0000-000000000000"
    edit: boolean = false;
    isDisable: boolean = false;
  }

  export class ClientDetailsBO{
    firstName :string ="";
    middleName :string ="";
    lastName :string ="";
    pmi :string ="";
    dob :string ="";
    street :string ="";
    city :string ="";
    zip :string ="";
    state :string ="";
    county :string ="";
    email :string ="";
    phone :string ="";
    age :number;
  }


  export class AgencyDetailsBO{
    name :string ="";
    npi :string ="";
    dob :string ="";
    street :string ="";
    city :string ="";
    zip :string ="";
    state :string ="";
    county :string ="";
    email :string ="";
    phone :string ="";
    age :number;
    fax :string ="";
    contactname  :string ="";
  }
export class ServiceDeliveryPlan {
     id: string = "00000000-0000-0000-0000-000000000000";
     serviceDeliveryPlanId:string="00000000-0000-0000-0000-000000000000";
     serviceDeliveryplanId:string="00000000-0000-0000-0000-000000000000";
    plandate: string | null;
    version: string;
    startdate: string | null;
    enddate: string | null;
    phoneNumber: string;
    directOwnCare: boolean | null;
    preferrdLanguages: string;
    needsInterpreter: boolean | null;
    aboutyou: string;
    prefferd_Outcomes: string;
    additionalInformation: string;
    isFullYearPlan: boolean | null;
    totalCFSSUnitsEligible: number | null;
    isEnhancedrate: boolean | null;
    is65OrOlder: boolean | null;
    usesWaiverOrProgram: boolean | null;
    typeOfWaiverOrProgram : string;
    modelTypename: string;
    willUsePERS: boolean | null;
    is_Goods_And_Service: boolean | null;
    bringMedications: boolean | null;
    bringMedicationItems: boolean | null;
    other: boolean | null;
    otherDetails: string;
    medicationInstructionsDetails: string;
    medicationTimeReminders: string;
    isSkillEnhancement_Included: boolean | null;
    workerAbsencePlan: string;
    medicalEmergencySigns: string;
    medicalEmergencySpecialConsiderations: string;
    vulnerabilitiesToAbuse: string;
    riskOfAbusingOthers: string;
    safetyStrategies: string;
    actionPlanIfAbused: string;
    containerName: string;
    personSignFilePath: string;
    parentalSignFilePath: string;
    providerSignFilePath: string;
    leadSignFilePath: string;
    personSignDate: string | null;
    providerSignDate: string | null;
    parentalSignDate: string | null;
    leadSignDate: string | null;
    personLastName: string;
    personPmi: string;
    personDob: string | null;
    agencyId: string;
    createdBy: string | null;
    createdIp: string;
    createdTime: string | null;
    modifiedBy: string | null;
    modifiedIp: string;
    modifiedTime: string | null;
    recordVersion: number;
    fmsBudget: FMSBudget = new FMSBudget();
    clientId: string;
    isRedirectionRequired: boolean | null;
    isHealthProceduresRequired: boolean | null;
    isMedicationsRequired: boolean | null;
    maintenancePlan: string;
    agencyModels: AgencyModel = new AgencyModel();
    providers: Providers[]=[];
    interpreters: Interpreter[]=[];
    medicalEmergencies: MedicalEmergencies[]=[];
    nonMedicalEmergencies: NonMedicalEmergencies[] =[];
    careCoordinator: CareCoordinator[]=[];
    participantRepresentative: ParticipantRepresentative[]=[];
    goodsAndServices: GoodsAndServices[]=[];
    healthProcedures: HealthProcedures[]=[];
    behaviours: Behaviour[]=[];
    instrumentalActivities: InstrumentalActivity[]=[];
    classes: Classes[]=[];
    adLs: ADLs[]=[];
    mhcpCost: MHCPCost = new MHCPCost();
    fmsProvider: FMSProvider = new FMSProvider();
    edit:boolean;
    signatureBOs:SignatureBO[]=[];
    clientPmi:string;
    clientInfoFirstName: string;
    clientInfoMiName: string;
    clientInfoLastName: string;
    clientInfoPmi: string;
    clientInfoDob: string | null;
    clientInfoStreet: string;
    clientInfoCity: string;
    clientInfoState: string;
    clientInfoZip: string;
    clientInfoCounty: string;
    clientInfoEmail: string;
    clientInfoPhone: string;
    clientInfoAge: string;
    consultantInfoName: string;
    consultantInfoPmi: string;
    consultantInfoPhone: string;
    consultantInfoStreet: string;
    consultantInfoCity: string;
    consultantInfoState: string;
    consultantInfoZip: string;
    consultantInfoContactName: string;
    consultantInfoEmail: string;
    consultantInfoFax: string;
    normalRate: number;
    enhancedRate: number;
    ptoTax_Percent: number;
    payrollTax_Percent: number;
    copy:boolean;
    leadAgencyComments: string;
    hasEvent: boolean;
    clientConfirmation : boolean;
    cfssWorkerBudget : number;
    additionalNotes : string;
    PaidLeave_Percent: number;
  revisionTypes: { participantRepresentative: boolean; goodsAndServices: boolean; pers: boolean; workerTraining: boolean; changingProviders: boolean; };
  summaryOfChanges: any;
  revisionDate: string | null;
  providerChangeTypes: {consultationServicesProvider: boolean; cfssProviderAgency: boolean; persProvider:boolean; fmsProvider: boolean;};
  isSharedCare:boolean;
}


export class SignatureBO {
    signatureFileString: string;
    fileName: string;
}


export class AgencyModel {
    id: string = "00000000-0000-0000-0000-000000000000";
    planSameUnitsEachMonth: boolean | null;
    plannedUnits: number | null;
    workerPreferencesDetails: string ="";
    trainingDevelopmentPlan: string ="";
    createdBy: string | null;
    createdIp: string;
    createdTime: string | null;
    modifiedBy: string | null;
    modifiedIp: string;
    modifiedTime: string | null;
    recordVersion: number;
    servicedeliveryPlanId: string;
    serviceDeliveryPlan: ServiceDeliveryPlan;
    monthlyUnitUsage: MonthlyUnitUsage = new MonthlyUnitUsage();
    agencyDetails: AgencyDetails[]=[];
}
export class FMSBudget {
    id: string = "00000000-0000-0000-0000-000000000000";
    budgetAmount: number | null;
    fmsFee: number | null;
    planMonths: number | null;
    is_Personal_Care_Workers: boolean | null;
    is_Prevention_Explained: boolean | null;
    createdBy: string | null;
    createdIp: string;
    createdTime: string | null;
    modifiedBy: string | null;
    modifiedIp: string;
    modifiedTime: string | null;
    recordVersion: number;
    jobDescription: string;
    workerBudgets: WorkerBudget[] =[];
    workerTasks: WorkerTask[]=[];
    serviceDeliveryPlanId: string;
    serviceDeliveryPlan: ServiceDeliveryPlan;
}


export class GoodsAndServices  {
    id: string = "00000000-0000-0000-0000-000000000000";
    goods_Or_Service: string ="";
    assessed_Need: string="";
    human_Support_It_Replaces: string="";
    cost: number =0;
    fms_Fee_Percentage: number | null;
    fMSBudgetId: string;
    agenCyModelId: string;
}
export class HealthProcedures {
    id: string = "00000000-0000-0000-0000-000000000000";
    need: string='';
    what_will_worker_do: string ="";
    how_will_worker_do: string="";
    fMSBudgetId: string;
    agencyModelId: string;
}
export class Classes {
    id: string = "00000000-0000-0000-0000-000000000000";
    className: string ="";
    trainingProvider: string ="";
    cost: number=0;
    fMSBudgetId: string ="";
    agencyModelId: string;
}
export class ADLs  {
    id: string = "00000000-0000-0000-0000-000000000000";
    assesedNeed: string ="";
    fromWhom: string ="";
    what_will_Caregiver_do: string ="";
    how_will_Caregiver_do: string ="";
    fMSBudgetId: string;
    agencyModelId: string;
}export class AgencyDetails {
    id: string = "00000000-0000-0000-0000-000000000000";
    agencyName: string ="";
    npi: string ="";
    phoneNumber: string ="";
    street: string ="";
    city: string ="";
    state: string ="";
    zipCode: string ="";
    contactName: string ="";
    emailAddress: string ="";
    faxNumber: string ="";
    agencyModelId: string;
}
export class InstrumentalActivity {

    id: string = "00000000-0000-0000-0000-000000000000";
    assesedNeed: string ="";
    what_will_Caregiver_do: string ="";
    how_will_Caregiver_do: string ="";
    fMSBudgetId: string ="";
    agencyModelId: string;
    fromwhom : string;
}
export class Behaviour {
    id: string = "00000000-0000-0000-0000-000000000000";
    when_I_do: string ="";
    it_means: string ="";
    worker_can_help_by: string ="";
    fMSBudgetId: string ="";
    agencyModelId: string ="";
}
export class MHCPCost {
    id: string = "00000000-0000-0000-0000-000000000000";
    equipment_ProviderName: string ="";
    installation_ProviderName: string ="";
    subscription_ProviderName: string ="";
    equipment_Cost: number =0;
    installation_Cost: number=0;
    subscription_Cost: number=0;
    fMSBudgetId: string;
    agencyModelId: string;
}
export class Providers {
    id: string = "00000000-0000-0000-0000-000000000000";
    providerName: string ="";
    specialty: string ="";
    phoneNumber: string ="";
    address: string ="";
    serviceDeliveryPlanId: string;
}
export class Interpreter {
    id: string = "00000000-0000-0000-0000-000000000000";
    name: string ="";
    relationShip: string ="";
    phonenumer: string ="";
    servicedeliveryPlanId: string;
}
export class MedicalEmergencies {
    id: string = "00000000-0000-0000-0000-000000000000";
    if_this_happens: string ="";
    contact: string ="";
    specialInstructions: string ="";
    serviceDeliveryPlanId: string;
}

export class NonMedicalEmergencies {
    id: string = "00000000-0000-0000-0000-000000000000";
    situation: string ="";
    special_Instructions: string ="";
    serviceDeliveryPlanId: string;
}
export class CareCoordinator  {
    id: string = "00000000-0000-0000-0000-000000000000";
    coordinator_Name: string ="";
    phoneNumber: string ="";
    email: string ="";
    city: string ="";
    state: string ="";
    zipCode: string ="";
    street: string ="";
    fax: string ="";
    serviceDeliveryPlanId: string;
}
export class ParticipantRepresentative {
    id: string = "00000000-0000-0000-0000-000000000000";
    firstName: string ="";
    lastName: string ="";
    email: string ="";
    address: string ="";
    city: string ="";
    state: string ="";
    zipCode: string ="";
    phoneNumber: string ="";
    serviceDeliveryPlanId: string;
}

export class WorkerTask  {
    id: string = "00000000-0000-0000-0000-000000000000";
    task: string ="";
    qualifications: string ="";
    fMSBudgetId: string;
}
export class WorkerBudget  {
    id: string = "00000000-0000-0000-0000-000000000000";
    worker_Name: string ="";
    hourly_Wage: number=0;
    no_Of_Hours_Per_Week: number=0;
    no_Of_Weeks: number=0;
    is_PTO_Applied: boolean;
    is_Payroll_Applied: boolean;
    is_Worker_Comp_Applied: boolean;
    percentageRate: number=0;
    totalCost: number=0;
    ptototalCost: number=0;
    payrolltotalCost: number=0;
    workertotalCost: number=0;
    fMSBudgetId: string ="";
    workerBudgetId :string= "00000000-0000-0000-0000-000000000000";
    is_Paid_Leave: boolean;
    
}

export class FMSProvider {
    id: string = "00000000-0000-0000-0000-000000000000";
    providerNameLid :string = "00000000-0000-0000-0000-000000000000";
    providerName: string ="";
    npi: string ="";
    phoneNumber: string ="";
    address: string ="";
    city: string ="";
    state: string ="";
    zipCode: string ="";
    contactName: string ="";
    email: string ="";
    fax: string ="";
    fmsAgencyId : string = "00000000-0000-0000-0000-000000000000";
    fMSBudgetId: string = "00000000-0000-0000-0000-000000000000";
    agenCyModelId:string = "00000000-0000-0000-0000-000000000000";
    providerKeyValue: null;
}
export class MonthlyUnitUsage  {
    id: string = "00000000-0000-0000-0000-000000000000";
    unitsEligibleFor: number =0;
    unitsJan: number=0;
    unitsFeb: number=0;
    unitsMar: number=0;
    unitsApr: number=0;
    unitsMay: number=0;
    unitsJun: number=0;
    unitsJul: number=0;
    unitsAug: number=0;
    unitsSep: number=0;
    unitsOct: number=0;
    unitsNov: number=0;
    unitsDec: number=0;
    totalUnitsUsed: number=0;
    agencyModelId: string;
}
export class GetClientAgencyBO {
    id: string ="";
    fullName: string ="";
    firstName: string ="";
    lastName: string ="";
    middleName: string ="";
    dob: string ="";
    age: number;
    street: string ="";
    street2: string ="";
    apt: string ="";
    phone1: string ="";
    phone2: string ="";
    county: string ="";
    city: string ="";
    state: string ="";
    zipCode: string ="";
    email: string ="";
    agencyId: string ="";
    agencyName: string ="";
    agencyEmail: string ="";
    agencyPhone: string ="";
    agencyFax: string ="";
    agencyStreet: string ="";
    agencyCity: string ="";
    agencyState: string ="";
    agencyZipCode: string ="";
    languages: string ="";
    pmi:string
}
export class GetAgencyDetailsBO {
    agencyId: string ="";
    agencyName: string ="";
    agencyEmail: string ="";
    agencyPhone: string ="";
    agencyFax: string ="";
    agencyStreet: string ="";
    agencyCity: string ="";
    agencyState: string ="";
    agencyZipCode: string ="";
    agencyNpi :string =""
}

export class EventBO{
    startDate:string;
    endDate:string;
    clientId:string;             
    serviceDeliveryPlanId:string;
    isedit:boolean= true;
}